import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
//window.axios = require('axios')
// import VueSlideBar from 'vue-slide-bar'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
import axios from 'axios'

import VuejsDialog from 'vuejs-dialog';

import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)
//  Vue.use('VueSlideBar', VueSlideBar)
import Api from "./mixins/Apicall";
import Appsettings from "./mixins/AppSettings";
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VueI18n from 'vue-i18n'
import { ENGLISH_TRANSLATIONS } from '@/localization/en';
import { IRISH_TRANSLATIONS } from '@/localization/ga';
import VueAgile from 'vue-agile';
Vue.use(VueAgile)
// import VueGtag from "vue-gtag";

Vue.config.productionTip = false
let app = '';
// Vue.use(VueGtag, {
//   config: { id: "UA-267119490-1" }
// });
Vue.use(VueI18n)

Vue.prototype.$http = axios;

Vue.mixin(Api);

Vue.mixin(Appsettings);

Vue.use(VuejsDialog);

const TRANSLATIONS = {
  en: ENGLISH_TRANSLATIONS,
  ga: IRISH_TRANSLATIONS
}
const i18n = new VueI18n({
  locale: 'en',
  messages: TRANSLATIONS,
})


const config = {
  apiKey: "AIzaSyCqCuQ2is8GXVE9WMllnhsrIl5E9pxv9zk",
  authDomain: "pinpoint-belfastrapidtransit.firebaseapp.com",
  projectId: "pinpoint-belfastrapidtransit",
  storageBucket: "pinpoint-belfastrapidtransit.appspot.com",
  messagingSenderId: "775729076773",
  appId: "1:775729076773:web:81cf64eda440262a40fdcc",
  measurementId: "G-XQREJF94ZV",
  databaseURL: "https://pinpoint-belfastrapidtransit.firebaseio.com"
};

firebase.initializeApp(config);

const analytics = firebase.analytics();
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
    router,
    store,
    firebase,
    i18n,
    render: h => h(App)
  }).$mount('#app')

  window.app = app;
}
});

